import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TemplateLibraryRepository {
  private readonly apiBase = '/api/reporting/templates';

  constructor(private http: HttpClient) {}

  getTemplateByName(templateName: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiBase}/name-exists?templateName=${templateName}`);
  }
}
